// ─── Types (mirror the Azure Function's MorosResponse) ───────────────────────

export type AgingBucket = "current" | "30-60" | "60-90" | "90-180" | "180+";

export interface MorosoRecord {
  cuscod: string;
  namecust: string;
  amtowing: number;
  amtdue: number;
  datelastpymt: string | null;
  amtlastpymt: number;
  invoiceCount: number;
  maxDaysOverdue: number;
  earliestDueDate: string | null;
  agingBucket: AgingBucket;
}

export interface MorosSummary {
  totalTenants: number;
  totalOwing: number;
  bucket30_60: number;
  bucket60_90: number;
  bucket90_180: number;
  bucket180plus: number;
  noPayment90plus: number;
}

export interface TrendPoint {
  month: string;
  totalInvoiced: number;
}

export interface MorosResponse {
  records: MorosoRecord[];
  summary: MorosSummary;
  trend: TrendPoint[];
  lastUpdated: string;
  source: "live" | "cache";
  warning?: string;
}

// ─── Fetch ───────────────────────────────────────────────────────────────────

const API_BASE =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:7071/api"
    : "/api");

export async function fetchMorosos(refresh = false): Promise<MorosResponse> {
  const url = `${API_BASE}/morosos${refresh ? "?refresh=true" : ""}`;
  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(`${res.status}: ${text}`);
  }
  return res.json() as Promise<MorosResponse>;
}
